<template>
  <div id="app" ref="appView">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->

    <div class="router">
      <router-view style="position: relative; z-index: 5" />
    </div>
    <foot-view></foot-view>

    <!-- <imgexhibite @showheadle="showheadle" v-show="ifshow && ifpath" ></imgexhibite> -->
    <imgexhibite @showheadle="showheadle" v-show="ifshow" ></imgexhibite>
	
  </div>
</template>

<!-- <script src="../component/rem.js"></script> -->
<!-- <script src="../component/browser.js"></script>
<script src="../component/polyfill.js"></script> -->
<script>
import imgexhibite from "@/com/imgexhibite.vue";

export default {
  components: {
     imgexhibite,
  },
  name: "app",
  data: function () {
		return { ifshow: true, ifpath:true};
  },
  
  //监听器
  watch: {	
	// 方法1
	'$route' (to, from) { //监听路由是否变化
	    var that = this
		// console.log(to.path)
		// console.log(from.path)
		// if(to.path == "/"){ //跳转到哪个页面
		// 	that.ifpath = true;
		// }else{
		// 	that.ifpath = false;
		// }
	},
  },
   
  mounted() {
	  if(window.name == ""){//首次被加载
        window.name = "refresh"; 
        this.ifshow=true;
    }else if(window.name == "refresh"){
        this.ifshow=false;
    }
  },

  methods: {
		showheadle(){
			this.ifshow = false
		}  
  },
  
};
</script>
<style>
/* 在这里写小屏幕设备的样式320 480 */
/* 这里写宽度大于321px小于1024px的样式(一般是平板电脑) */
/* @media screen and (max-width: 750px) {
  .title {
      -webkit-transform: scale(0.7);
  }
  .webkit,
  .hr {
      -webkit-transform: scale(0.7);
  }

}

@media screen and (min-width: 320px) and (max-width: 480px){
  
	 
}
@media only screen and (min-width: 321px) and (max-width: 1024px){
   
} 
@media only screen and (min-width: 1029px){
	 page,
	 #app {
	    min-width: 1300px;
	 }
} */
.plac{
  color: #bbbbbb!important;
}
.el-image__inner--center {
    top: 0px!important;
    left: 0px!important;
    transform: translate(0%, 0%)!important;
}
.min-w{
  min-width: 1300px;
}
.w13{
  width: 1300px;
}
.min-w12{
  min-width: 1200px;
}
.w12{
  width: 1200px;
}
.min-h{
  min-height: 600px;
}
page,
#app {
  -webkit-text-size-adjust: none;
  overflow: hidden;
  position: relative;
  min-width: 1300px;
}

.router {
  position: relative;
  z-index: 4;
  height: 100%;
}
/*每个页面公共css */
input:active {
  border: none;
  outline: none; /* 去除选中状态边框 */
  background-color: rgba(0, 0, 0, 0); /* 透明背景 */
}
input {
  border: none;
  outline: none; /* 去除选中状态边框 */
  background-color: rgba(0, 0, 0, 0); /* 透明背景 */
}
input::-webkit-input-placeholder {
  color: #bbbbbb;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bbbbbb;
}
input::-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */

  color: #bbbbbb;
}
input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */

  color: #bbbbbb;
}
input[type="checkbox"] {
  appearance: none;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none;
  visibility: hidden;
  cursor: pointer;
  margin: 0;
}
/* 初始状态 */
input[type="checkbox"] {
  /* background-image:url(""); */
  border: 0.01rem solid #999999 !important;
  width: 2.88rem;
  height: 2.88rem;
  padding: 0 !important;
}
/* 选中 */
input[type="checkbox"]:checked {
  background: url(assets/gou.png) no-repeat center / 100% 100%;
}

.imgcenter {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: auto !important;
}
.sbs {
  cursor: pointer;
}
.max {
  width: 100%;
  height: 100%;
}
.maxwidth {
  width: 100%;
}

.right {
  float: right;
}
.left {
  float: left;
}

.pagecentbox {
  max-width: 1400px;
  width: 14rem;
  margin: 0 auto;
  /* display: flex;
  justify-content: space-between; */
  margin: 0.3rem auto 0;
  overflow: hidden;
  padding: 0.02rem;
}
.pagecentbox > div:nth-child(2n + 1) {
  float: left;
}
.pagecentbox > div:nth-child(2n + 2) {
  float: right;
}
.hand:hover {
  cursor: pointer;
}
.titleview {
  height: 0.38rem;
  background: #e41e15;
  width: 100%;
}
/*包含以下五种的链接*/
a {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
}
.boxtitle {
  width: 10.62rem;
  overflow: hidden;
  margin: 0.1rem 0 0.2rem 0.58rem;
  border-bottom: 0.01rem solid rgba(140, 140, 140, 0.24);
}
.overf-elli {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
